import { actionsStyles } from "@dana/Overrides/Widgets/ProductList/ProductListActions";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { css } from "styled-components";

actionsStyles.wrapper = mergeToNew(actionsStyles.wrapper, {
  css: css`
    margin-bottom: 16px;
  `
});

actionsStyles.productActionLinksWrapper = mergeToNew(actionsStyles.productActionLinksWrapper, {
    css: css`
        display: flex;
        align-items: center;
        width: 100%;
        justify-content: space-between;
        margin-top: 16px;
    `,
});

actionsStyles.addToCartWrapper = mergeToNew(actionsStyles.addToCartWrapper, {
    css: css`
        margin-top: 16px;
    `,
});


actionsStyles.addToListWrapper = mergeToNew(actionsStyles.addToListWrapper, {
    css: css`
        margin-top: 0;
        min-height: auto;
    `,
});